import CarPageBasicComponent from './car-page-basic-component';

class CarPageContactPanel extends CarPageBasicComponent {

  state = { isInCart: false };

  /**
   * Initializes the component: renders, binds, starts observers etc...
   * @param {[CarPageApp]} carPageApp optional, if doesn't exist, it's created. (The CarPageApp component is a singleton)
   */
  constructor(carPageApp) {
    super(carPageApp);
    this.element = document.querySelector('.car');
    this.initState();
    this.initControls();
    this.render();
  }

  /**
   * initializes the component's control elements.
   */
  initControls() {
    this.addCartButtons = this.element?.querySelectorAll('.add-cart-button');
  }

  /**
   * Isolate from the entire app state only the part that concerns the component,
   * and only observe changes in that sub state.
   * @param  {object} state receives the app state from controller app
   * @return {object} the isolated sub state, for example state.calculator.calculatorType
   */
  filterState(state) {
    // eslint-disable-next-line no-prototype-builtins
    if (typeof state === 'object' && state.hasOwnProperty('cart')) {
      return { ...state.cart };
    }
    return {};
  }

  /**
   * Updates the visible component when asked. In this case calls the visibility
   * toggle of the external component.
   */
  render() {
    if( this.addCartButtons ) {

      // This also updates cart button in sticky header
      this.addCartButtons.forEach(button => {
        const addToCartLabels = button.querySelectorAll('.add-to-cart-label');
        const goToCartLabels = button.querySelectorAll('.go-to-cart-label');

        if (this.state.isInCart) {
          addToCartLabels.forEach(label => label.hidden = true);
          goToCartLabels.forEach(label => label.hidden = false);
        } else {
          addToCartLabels.forEach(label => label.hidden = false);
          goToCartLabels.forEach(label => label.hidden = true);
        }
      });
    }
  }
}

export default CarPageContactPanel;

